import React, { useState, useRef, useEffect } from "react";
import { Form, FormControl, Row, Col, Button, Card, Container } from "react-bootstrap";
import "./component.css";
import { useIntl } from "react-intl";
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import './keyboard.css';

export const EncounterLoginComponentTotem = ({ history }) => {

    const getClassByMode = (modality) => {
        return `functional-button-${modality}-mode`;
    };

    const getStyleClassButton = (button) => {
        if (button === "{lock}") {
            return getClassByMode(lockIsActive ? "active" : "normal");
        } else if (button === "{shift}") {
            if (lockIsActive) {
                return getClassByMode("disable");
            } else if (layoutName === "shift") {
                return getClassByMode("active");
            } else {
                return getClassByMode("normal");
            }
        } else if (button === "{bksp}") {
            if (code.length > 0) {
                return getClassByMode("normal");
            } else {
                return getClassByMode("disable");
            }
        }
    };

    const [code, setCode] = useState("");
    const [layoutName, setLayoutName] = useState("default");
    const [lockIsActive, setLockState] = useState(false);

    const inputRef = useRef();
    const keyboardRef = useRef();

    // Keep track of last code entered through the scanner.
    const lastKeyboardValue = useRef('');

    const setFocus = (caretPosition) => {
        inputRef.current.focus();
        inputRef.current.setSelectionRange(caretPosition, caretPosition);
    };

    /**
     * Handles changes triggered through the keyboard.
     * @param {*} dataCode
     */
    const onKeyboardChange = (dataCode) => {
        if (dataCode !== code) {
            const newCode = dataCode?.trim();

            setCode(newCode);
            lastKeyboardValue.current = newCode;

            if (keyboardRef.current?.caretPosition) {
                const caretPosition = keyboardRef.current?.caretPosition;
                setFocus(caretPosition);
            } else {
                const caretPosition = code.length + 1;
                setFocus(caretPosition);
            }
        }
    };

    /**
     * Hanldes any changes to the input field.
     * NOTE(s): 
     *   - The input change is only triggered by the barcode scanner, user only
     *     interacts with the virtual keyboard.
     *   - When the first char is read by the scanner, all chars entered with the
     *     keyboard are removed and the keyboard internal state is reset.
     *   - At this point, the scanner should continue to stream chars in the input.
     *     When done, the form is automatically submitted with the value decoded by 
     *     the scanner.
     * @param {*} dataCode
     */
    const onInputChange = dataCode => {
        let newCode = dataCode?.trim();
        keyboardRef.current.clearInput();
        lastKeyboardValue.current = '';
        setCode(newCode);
    };

    const onInputKeydown = () => {
        if (lastKeyboardValue.current) {
            setCode('');
        }
    };

    const onKeyPress = (button) => {
        /**
         * shift-lock functionality
         */
        handleShiftLockButton(button);
    };

    useEffect(
        () => {
            const handleDocumentMousedown = event => {
                const eventTarget = event.target;

                // Clicked inside the input, do nothing.
                if (inputRef.current.contains(eventTarget) || keyboardRef.current.keyboardDOM.contains(eventTarget)) {
                    return;
                }

                // In case the click is done outside the keyboard and the input (whenever on the page),
                // just prevent the input to lose the focus and put the cursor at the end of the field.
                event.preventDefault();
                setFocus(inputRef.current.value?.length);
            };

            document.addEventListener('mousedown', handleDocumentMousedown);

            return () => {
                document.removeEventListener('mousedown', handleDocumentMousedown);
            };
        },
        []
    );

    const handleShiftLockButton = (button) => {
        if (button !== "{lock}" && button !== "{shift}" && !lockIsActive && layoutName === "shift") setLayoutName("default");
        else if (button === "{lock}") {
            setLockState(!lockIsActive);
            if (layoutName !== "shift" || lockIsActive) setLayoutName(layoutName === "default" ? "shift" : "default");
        }
        else if (button === "{shift}" && !lockIsActive) setLayoutName(layoutName === "default" ? "shift" : "default");
    };

    const intl = useIntl();

    function submitLogin() {
        history.push({ pathname: `/totem/monitoraggio/${code}` });
    }

    return (
        <Form onSubmit={submitLogin}>
            <Row className="align-items-center justify-content-center">
                <Col lg={10} md={10} sm={10} xs={10}>
                    <Container style={{ maxWidth: 620 }}>
                        <Row className="align-items-center justify-content-center">
                            <Col className="border-card">
                                <FormControl
                                    autoFocus
                                    style={{ height: 50, fontSize: "75%", borderRadius: "10px" }}
                                    className="container-fluid"
                                    type="string"
                                    value={code}
                                    ref={inputRef}
                                    onKeyDown={() => onInputKeydown()}
                                    onChange={ev => onInputChange(ev.target.value)}
                                    placeholder={intl.formatMessage({ id: "monitoraggioPazientePage.placeholderInputAggiungiPazienti" })}
                                />
                            </Col>
                        </Row>
                        <Row className="align-items-center justify-content-center" style={{ textAlign: "center", marginTop: "5%" }}>
                            <Container fluid={"true"} >
                                <Keyboard
                                    onChange={input => onKeyboardChange(input)}
                                    onKeyPress={button => onKeyPress(button)}
                                    keyboardRef={el => keyboardRef.current = el}
                                    layout={{
                                        'default': [
                                            '1 2 3 4 5 6 7 8 9 0 {bksp}',
                                            'q w e r t y u i o p',
                                            '{lock} a s d f g h j k l',
                                            '{shift} z x c v b n m',
                                        ],
                                        'shift': [
                                            '~ ! @ # $ % ^ & * _ {bksp}',
                                            'Q W E R T Y U I O P',
                                            '{lock} A S D F G H J K L',
                                            '{shift} Z X C V B N M',
                                        ]
                                    }}
                                    layoutName={layoutName}
                                    buttonTheme={[
                                        {
                                            class: getStyleClassButton("{lock}"),
                                            buttons: "{lock}"
                                        },
                                        {
                                            class: getStyleClassButton("{shift}"),
                                            buttons: "{shift}"
                                        },
                                        {
                                            class: getStyleClassButton("{bksp}"),
                                            buttons: "{bksp}"
                                        }
                                    ]}
                                    useMouseEvents={true}
                                    disableCaretPositioning={false}
                                    preventMouseDownDefault={true}
                                    display={{
                                        '{bksp}': `${intl.formatMessage({ id: "codContattoPageTotem.keyboardLabels.bksp" })} ⌫`,
                                        '{shift}': `${intl.formatMessage({ id: "codContattoPageTotem.keyboardLabels.shift" })} ⇧`,
                                        '{lock}': `${intl.formatMessage({ id: "codContattoPageTotem.keyboardLabels.lock" })} ⇪`
                                    }} />
                            </Container>
                        </Row>
                        <Row><br /></Row>
                        <Row className="align-items-center justify-content-center">
                            <Col>
                                <Card className="border-0 border-card d-block">
                                    <Button
                                        type="submit"
                                        className="container-fluid font-weight-bold"
                                        variant={"danger"}
                                        style={{ display: "inherit", height: 50, fontSize: "75%", textTransform: "uppercase", borderRadius: "10px", marginTop: "3.5%" }}
                                        disabled={code.length === 0}>
                                        {intl.formatMessage({ id: "monitoraggioPazientePage.labelBottoneAggiungiPazienti" })}
                                    </Button>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
        </Form>
    );
}